import AWS from 'aws-sdk'
import axios from 'axios'
import Store from '@/store/index.js'

export async function uploadFileBySDK (params) {
  return await axios
    .post('/file/request-upload-for-sdk', params, { requestBase: 'GATEWAY' })
    .then(res => {
      if (res.data.errorCode === '0x0') {
        const result = res.data.result
        AWS.config.region = result.identityPoolRegion
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: result.identityPoolId
        })
        return result
      }
    })
}

export async function doUploadFile (uploadParams, file) {
  const uploadObj = new AWS.S3.ManagedUpload({
    params: {
      Bucket: uploadParams.bucket,
      Key: uploadParams.objectKey,
      Body: file.raw,
      ACL: 'public-read'
    },
    service: new AWS.S3({
      region: uploadParams.region
    })
  })

  uploadObj.on('httpUploadProgress', function(progress) {
    const percent = Math.round((progress.loaded / progress.total) * 100);
    Store.state.uploadImagePercent[uploadParams.fileName] = percent
    console.log('percent', percent)
  })

  await uploadObj.promise().then(() => {
    addFile(uploadParams)
  })
}

export async function addFile (uploadParams) {
  const params = {
    bucketId: uploadParams.bucketId,
    directoryId: uploadParams.directoryId,
    objectKey: uploadParams.objectKey
  }

  return await axios
    .post('/file/add-file', params, { requestBase: 'GATEWAY' })
    .then(res => {
      if (res.data.errorCode === '0x0') {
        return res.data.result
      }
    })
}

export async function getImageWidthHeight (file) {
  return new Promise(function (resolve, reject) {
    const url = window.URL || window.webkitURL
    const image = new Image()
    image.onload = () => {
      resolve({ width: image.width, height: image.height })
    }
    image.src = url.createObjectURL(file);
  }).then(

  )
    .catch((error) => {
      reject(error)
    })
}

export default {}